export const TOUR_MODAL_HEIGHT =
  'md:h-[calc(91.667vw/2.125+108px)] lg:h-[541px]';
